import $http from '@/api/index';

/**
 * @typedef {{}} FileCard
 * @property {Number} id
 * @property {String} name
 * @property {Number} collectionId
 * @property {String} publicUrl
 * @property {String} mimeType
 * @property {String} extension
 * @property {String} creationDate
 */
export default {
  /**
   * Fetches a file card.
   * @param id
   * @return {Promise<FileCard>}
   */
  async fetch(id) {
    return $http.get(`/api/binaryFile/${id}`);
  },
};
